import { createAction } from "redux-starter-kit";
import { OPEN_EDIT_NOTE } from "../types";

const openEditNote = (id, note) => createAction(OPEN_EDIT_NOTE)({ id, note });

export default openEditNote;
